export const outlinedFieldProps = {
    variant: 'outlined',
    size: 'small',
    fullWidth: true,
};

export const disabledOutlinedSx = {
    '& .MuiOutlinedInput-root.Mui-disabled': {
        borderRadius: '12px',
        backgroundColor: 'action.hover',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'divider',
    },
    '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: 'text.secondary',
    },
};
